<div style="display: flex; flex-direction: column; overflow: hidden; height: 100%">
    <div class="p-10" style="display: flex; flex-direction: column; flex-grow: 1; height: 100%; overflow: hidden">
        <mat-card appearance="outlined" style="height: 100%; overflow: hidden">
            <mat-card-content style="height: auto; display: flex; flex-direction: column; overflow: hidden; justify-content: space-between">
                <div style="display: flex; flex-direction: row; justify-content: space-between">
                    <form [formGroup]="flightsFilterForm" style="display: flex; overflow-x: auto">
                        <mat-form-field [floatLabel]="'always'">
                            <mat-label>{{ "FLIGHTS.TABLE.helicopter" | translate }}</mat-label>
                            <mat-select [placeholder]="'FLIGHTS.TABLE.helicopter' | translate" formControlName="helicopters" multiple #helicopterSelect>
                                @if (helicopterList.length > 1) {
                                    <mat-option [value]="-1" (onSelectionChange)="onAllHelicoptersChosen($event)">
                                        {{ "EXPORT.selectAll" | translate }}
                                    </mat-option>
                                }
                                @for (helicopter of helicopterList; track helicopter.id) {
                                    <mat-option [value]="helicopter.id" (onSelectionChange)="onHelicopterChosen($event, helicopter.id)">
                                        {{ helicopter.registrationMark }}
                                    </mat-option>
                                }
                            </mat-select>
                            @if (flightsFilterForm.controls["helicopters"].hasError("required")) {
                                <mat-error>{{ "GENERAL.required" | translate }}</mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field [floatLabel]="'always'">
                            <mat-label>Block</mat-label>
                            <mat-select placeholder="Block" formControlName="blockId">
                                @for (block of blockOptions; track block) {
                                    <mat-option [value]="block.value" (onSelectionChange)="onBlockChosen($event, block.value)">{{ block.label }}</mat-option>
                                }
                            </mat-select>
                            @if (flightsFilterForm.controls["blockId"].hasError("required")) {
                                <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field [floatLabel]="'always'" disabled="true">
                            <mat-label>{{ "FLIGHTS.TABLE.startDate" | translate }}</mat-label>
                            <input
                                matInput
                                [matDatepicker]="startDateDatePicker"
                                #startDateInput
                                [placeholder]="'FLIGHTS.TABLE.startDate' | translate"
                                name="startDate"
                                [min]="minDate"
                                [max]="maxDate !== null ? maxDate : today"
                                formControlName="startDate"
                                (dateChange)="onDateChosen($event.value)"
                            />
                            <div matSuffix class="multiple-suffixes">
                                @if (
                                    flightsFilterForm.controls["startDate"].value !== null &&
                                    flightsFilterForm.controls["startDate"].value !== undefined &&
                                    flightsFilterForm.controls["startDate"].enabled
                                ) {
                                    <button mat-icon-button aria-label="Clear" (click)="onClearStartDate()" style="margin-right: -14px">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                }
                                <mat-datepicker-toggle [for]="startDateDatePicker"></mat-datepicker-toggle>
                            </div>
                            <mat-datepicker #startDateDatePicker></mat-datepicker>
                            @if (flightsFilterForm.controls["startDate"].hasError("matDatepickerParse")) {
                                <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                            }
                            @if (flightsFilterForm.controls["startDate"].hasError("required")) {
                                <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field [floatLabel]="'always'">
                            <mat-label>{{ "FLIGHTS.TABLE.endDate" | translate }}</mat-label>
                            <input
                                matInput
                                [matDatepicker]="endDateDatePicker"
                                #endDateInput
                                [placeholder]="'FLIGHTS.TABLE.endDate' | translate"
                                name="endDate"
                                [min]="minDate"
                                [max]="maxDate !== null ? maxDate : today"
                                formControlName="endDate"
                                (dateChange)="onDateChosen($event.value)"
                            />
                            <div matSuffix class="multiple-suffixes">
                                @if (
                                    flightsFilterForm.controls["endDate"].value !== null &&
                                    flightsFilterForm.controls["endDate"].value !== undefined &&
                                    flightsFilterForm.controls["endDate"].enabled
                                ) {
                                    <button mat-icon-button aria-label="Clear" (click)="onClearEndDate()" style="margin-right: -14px">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                }
                                <mat-datepicker-toggle [for]="endDateDatePicker"></mat-datepicker-toggle>
                            </div>
                            <mat-datepicker #endDateDatePicker></mat-datepicker>
                            @if (flightsFilterForm.controls["endDate"].hasError("matDatepickerParse")) {
                                <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                            }
                            @if (flightsFilterForm.controls["endDate"].hasError("required")) {
                                <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Search</mat-label>
                            <input matInput (input)="onSearch($event)" #searchInput />
                            @if (searchInput.value) {
                                <button matSuffix mat-icon-button aria-label="Clear" (click)="onClearSearch()"><mat-icon>close</mat-icon></button>
                            }
                        </mat-form-field>
                        @if (hasPresetFilters) {
                            <mat-form-field [floatLabel]="'always'">
                                <mat-label>Preset Filters</mat-label>
                                <mat-select placeholder="Preset Filter" formControlName="presetFilter">
                                    <mat-option [value]="-1" (onSelectionChange)="onPresetFilterChosen($event)">No Filter</mat-option>
                                    @for (filter of presetFilterOptions; track filter) {
                                        <mat-option [value]="filter.id" (onSelectionChange)="onPresetFilterChosen($event, filter)"> {{ filter.name }}</mat-option>
                                    }
                                </mat-select>
                                @if (flightsFilterForm.controls["blockId"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                        }
                        <mat-form-field [floatLabel]="'always'">
                            <mat-label>Data</mat-label>
                            <mat-select placeholder="Data" [value]="0">
                                <mat-option [value]="0" (onSelectionChange)="onDataChosen($event)"> All Data </mat-option>
                                <mat-option [value]="1" (onSelectionChange)="onDataChosen($event)"> Original </mat-option>
                                <mat-option [value]="2" (onSelectionChange)="onDataChosen($event)"> Edited </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </form>
                    <div style="display: flex; align-items: center; justify-content: end">
                        <button mat-icon-button (click)="openSettingsDialog()">
                            <mat-icon>settings</mat-icon>
                        </button>
                        <button mat-raised-button color="primary" (click)="exportToExcel(gridComponent)">
                            <mat-icon>download</mat-icon>
                            Export
                        </button>
                    </div>
                </div>
                @let matPrimaryColor = "#4050b5";
                @let white = "#ffffff";
                @let defaultWidth = 140;
                @let defaultMinResizableWidth = 90;
                <div style="display: flex; flex-grow: 1; flex-direction: column; overflow: hidden; max-height: 100%; height: auto">
                    @let separator = "|";
                    <kendo-grid
                        #gridComponent
                        style="height: 100%"
                        [kendoGridBinding]="data"
                        [data]="gridView"
                        [sort]="state.sort"
                        [filter]="state.filter"
                        [group]="state.group"
                        [scrollable]="'scrollable'"
                        [filterable]="'menu'"
                        [size]="'medium'"
                        [sortable]="true"
                        [resizable]="true"
                        [groupable]="true"
                        [reorderable]="true"
                        (dataStateChange)="dataStateChange($event)"
                        (sortChange)="onSortChange($event)"
                        (excelExport)="onExcelExport($event)"
                        (filterChange)="onFilterChange($event)"
                        [selectable]="{
                            checkboxOnly: false,
                            enabled: true,
                            drag: true,
                            mode: 'multiple',
                        }"
                        [pageSize]="state.take"
                        [pageable]="{
                            info: true,
                            type: 'numeric',
                            buttonCount: 8,
                            position: 'bottom',
                            previousNext: true,
                            pageSizes: pageSizes,
                        }"
                    >
                        <kendo-grid-excel [fileName]="getFileName()" [fetchData]="configureExport" [filterable]="true">
                            @for (group of gridColumns; track group.id) {
                                <kendo-excelexport-column-group
                                    [title]="getColumnTitleById(group.id)"
                                    [headerCellOptions]="{
                                        textAlign: 'center',
                                        background: matPrimaryColor,
                                        color: white,
                                    }"
                                >
                                    @if (!group.groupedColumns) {
                                        @for (c of group.columns; track c.def) {
                                            @let textAlign = c.leftAligned ? "left" : "center";
                                            @if (!hideColumnsBasedOnHelicopterData(c.def)) {
                                                <kendo-excelexport-column
                                                    [width]="c.width ?? defaultWidth"
                                                    [field]="c.def"
                                                    [title]="c.label"
                                                    [hidden]="c.hidden"
                                                    [headerCellOptions]="{
                                                        textAlign: textAlign,
                                                        background: matPrimaryColor,
                                                        color: white,
                                                    }"
                                                    [cellOptions]="{
                                                        wrap: true,
                                                        format: getExcelFormat(c.format),
                                                        textAlign: textAlign,
                                                    }"
                                                    [footerCellOptions]="{
                                                        textAlign: textAlign,
                                                        format: getExcelFormat(c.format),
                                                        background: matPrimaryColor,
                                                        color: white,
                                                    }"
                                                >
                                                    <ng-template kendoExcelExportFooterTemplate>
                                                        {{ sumColumn(c.def, exportData) }}
                                                    </ng-template>
                                                </kendo-excelexport-column>
                                            }
                                        }
                                    } @else {
                                        @for (subgroup of group.groupedColumns; track subgroup.id.toString()) {
                                            @if (subgroup.id | isNumber) {
                                                @for (c of subgroup.columns; track c.def) {
                                                    @let textAlign = c.leftAligned ? "left" : "center";
                                                    @if (!hideColumnsBasedOnHelicopterData(c.def)) {
                                                        <kendo-excelexport-column
                                                            [width]="c.width ?? defaultWidth"
                                                            [field]="c.def"
                                                            [title]="c.label"
                                                            [hidden]="c.hidden"
                                                            [headerCellOptions]="{
                                                                textAlign: textAlign,
                                                                background: matPrimaryColor,
                                                                color: white,
                                                            }"
                                                            [cellOptions]="{
                                                                wrap: true,
                                                                format: getExcelFormat(c.format),
                                                                textAlign: textAlign,
                                                            }"
                                                            [footerCellOptions]="{
                                                                textAlign: textAlign,
                                                                format: getExcelFormat(c.format),
                                                                background: matPrimaryColor,
                                                                color: white,
                                                            }"
                                                        >
                                                            <ng-template kendoExcelExportFooterTemplate>
                                                                {{ sumColumn(c.def, exportData) }}
                                                            </ng-template>
                                                        </kendo-excelexport-column>
                                                    }
                                                }
                                            } @else if (!hideSubgroupBasedOnHelicopterData(subgroup.id)) {
                                                <kendo-excelexport-column-group
                                                    [title]="getColumnTitleById(subgroup.id)"
                                                    [headerCellOptions]="{
                                                        textAlign: 'center',
                                                        background: matPrimaryColor,
                                                        color: white,
                                                    }"
                                                >
                                                    @for (c of subgroup.columns; track c.def) {
                                                        @if (!hideColumnsBasedOnHelicopterData(c.def)) {
                                                            @let textAlign = c.leftAligned ? "left" : "center";
                                                            <kendo-excelexport-column
                                                                [width]="c.width ?? defaultWidth"
                                                                [field]="c.def"
                                                                [title]="c.label"
                                                                [hidden]="c.hidden"
                                                                [headerCellOptions]="{
                                                                    textAlign: textAlign,
                                                                    background: matPrimaryColor,
                                                                    color: white,
                                                                }"
                                                                [cellOptions]="{
                                                                    wrap: true,
                                                                    format: getExcelFormat(c.format),
                                                                    textAlign: textAlign,
                                                                }"
                                                                [footerCellOptions]="{
                                                                    textAlign: textAlign,
                                                                    format: getExcelFormat(c.format),
                                                                    background: matPrimaryColor,
                                                                    color: white,
                                                                }"
                                                            >
                                                                <ng-template kendoExcelExportFooterTemplate>
                                                                    {{ sumColumn(c.def, exportData) }}
                                                                </ng-template>
                                                            </kendo-excelexport-column>
                                                        }
                                                    }
                                                </kendo-excelexport-column-group>
                                            }
                                        }
                                    }
                                </kendo-excelexport-column-group>
                            }
                        </kendo-grid-excel>
                        @for (group of gridColumns; track group.id) {
                            <kendo-grid-column-group [title]="getColumnTitleById(group.id)">
                                @if (!group.groupedColumns) {
                                    @for (c of group.columns; track c.def) {
                                        @let textAlign = { "text-align": c.leftAligned ? "left" : "center" };
                                        @if (!hideColumnsBasedOnHelicopterData(c.def)) {
                                            <kendo-grid-column
                                                [headerClass]="{
                                                    'k-justify-content-center': !c.leftAligned,
                                                }"
                                                [width]="c.width ?? defaultWidth"
                                                [field]="c.def"
                                                [title]="c.label"
                                                [draggable]="c.draggable"
                                                [format]="c.format"
                                                [hidden]="c.hidden"
                                                [filter]="getFilterType(c.format)"
                                                [sticky]="c.def === 'flightNumber'"
                                                [headerStyle]="textAlign"
                                                [style]="textAlign"
                                                [footerStyle]="textAlign"
                                                [minResizableWidth]="c.width ?? defaultMinResizableWidth"
                                            >
                                                <ng-template kendoGridCellTemplate let-dataItem>
                                                    @let cancelledData = !dataItem?.isEdited && filterEdited(dataItem);
                                                    <div
                                                        [ngStyle]="{
                                                            'text-decoration': cancelledData && currentDataFilter !== DataFilter.Original ? 'line-through' : 'none',
                                                            'text-decoration-color': cancelledData && currentDataFilter !== DataFilter.Original ? 'red' : 'unset',
                                                        }"
                                                    >
                                                        @let data = dataItem | accessValue: c.def;
                                                        @let containsSeparator = data?.toString().includes(separator) || false;
                                                        @let containsLineBreak = data?.toString().includes("<br>") || false;
                                                        @if (containsSeparator) {
                                                            <span>
                                                                <span [style.color]="'red'">{{ data.split(separator)[0] }} |</span>
                                                                {{ data.split(separator)[1] }}
                                                            </span>
                                                        } @else if (containsLineBreak) {
                                                            <span [innerHTML]="data"></span>
                                                        } @else if (!!data && data.toString() !== "0") {
                                                            @if (data | isNumber) {
                                                                @if (c.format === "n2") {
                                                                    {{ Number(Number(data).toFixed(2)) }}
                                                                } @else {
                                                                    {{ Number(data) }}
                                                                }
                                                            } @else if (c.format?.includes("d")) {
                                                                {{ data | date: c.format }}
                                                            } @else {
                                                                {{ data }}
                                                            }
                                                        }
                                                    </div>
                                                </ng-template>
                                                <ng-template kendoGridFooterTemplate>
                                                    {{ sumColumn(c.def, gridView?.data) }}
                                                </ng-template>
                                            </kendo-grid-column>
                                        }
                                    }
                                } @else {
                                    @for (subgroup of group.groupedColumns; track subgroup.id.toString()) {
                                        @if (subgroup.id | isNumber) {
                                            @for (c of subgroup.columns; track c.def) {
                                                @let textAlign = { "text-align": c.leftAligned ? "left" : "center" };
                                                @if (!hideColumnsBasedOnHelicopterData(c.def)) {
                                                    <kendo-grid-column
                                                        [headerClass]="{
                                                            'k-justify-content-center': !c.leftAligned,
                                                        }"
                                                        [width]="c.width ?? defaultWidth"
                                                        [field]="c.def"
                                                        [title]="c.label"
                                                        [draggable]="c.draggable"
                                                        [format]="c.format"
                                                        [hidden]="c.hidden"
                                                        [filter]="getFilterType(c.format)"
                                                        [sticky]="c.def === 'flightNumber'"
                                                        [headerStyle]="textAlign"
                                                        [style]="textAlign"
                                                        [footerStyle]="textAlign"
                                                        [minResizableWidth]="c.width ?? defaultMinResizableWidth"
                                                    >
                                                        <ng-template kendoGridCellTemplate let-dataItem>
                                                            @let cancelledData = !dataItem?.isEdited && filterEdited(dataItem);
                                                            <div
                                                                [ngStyle]="{
                                                                    'text-decoration': cancelledData && currentDataFilter !== DataFilter.Original ? 'line-through' : 'none',
                                                                    'text-decoration-color': cancelledData && currentDataFilter !== DataFilter.Original ? 'red' : 'unset',
                                                                }"
                                                            >
                                                                @let data = dataItem | accessValue: c.def;
                                                                @let containsSeparator = data?.toString().includes(separator) || false;
                                                                @let containsLineBreak = data?.toString().includes("<br>") || false;
                                                                @if (containsSeparator) {
                                                                    <span>
                                                                        <span [style.color]="'red'">{{ data.split(separator)[0] }} |</span>
                                                                        {{ data.split(separator)[1] }}
                                                                    </span>
                                                                } @else if (containsLineBreak) {
                                                                    <span [innerHTML]="data"></span>
                                                                } @else if (!!data && data.toString() !== "0") {
                                                                    @if (data | isNumber) {
                                                                        @if (c.format === "n2") {
                                                                            {{ Number(Number(data).toFixed(2)) }}
                                                                        } @else {
                                                                            {{ Number(data) }}
                                                                        }
                                                                    } @else if (c.format?.includes("d")) {
                                                                        {{ data | date: c.format }}
                                                                    } @else {
                                                                        {{ data }}
                                                                    }
                                                                }
                                                            </div>
                                                        </ng-template>
                                                        <ng-template kendoGridFooterTemplate>
                                                            {{ sumColumn(c.def, gridView?.data) }}
                                                        </ng-template>
                                                    </kendo-grid-column>
                                                }
                                            }
                                        } @else if (!hideSubgroupBasedOnHelicopterData(subgroup.id)) {
                                            <kendo-grid-column-group [title]="getColumnTitleById(subgroup.id)">
                                                @if (subgroup.id === "location") {
                                                    <ng-template kendoGridHeaderTemplate>
                                                        <div class="custom-header-content">
                                                            {{ getColumnTitleById(subgroup.id) }}
                                                            <kendo-textbox
                                                                [placeholder]="'Search fuel depots...'"
                                                                (valueChange)="filterGroup($event)"
                                                                style="width: 150px; margin-left: 10px"
                                                            ></kendo-textbox>
                                                        </div>
                                                    </ng-template>
                                                }
                                                @for (c of subgroup.columns; track c.def) {
                                                    @let textAlign = { "text-align": c.leftAligned ? "left" : "center" };
                                                    @if (!hideColumnsBasedOnHelicopterData(c.def)) {
                                                        <kendo-grid-column
                                                            [headerClass]="{
                                                                'k-justify-content-center': !c.leftAligned,
                                                            }"
                                                            [width]="c.width ?? defaultWidth"
                                                            [field]="c.def"
                                                            [title]="c.label"
                                                            [draggable]="c.draggable"
                                                            [format]="c.format"
                                                            [hidden]="c.hidden"
                                                            [filter]="getFilterType(c.format)"
                                                            [sticky]="c.def === 'flightNumber'"
                                                            [headerStyle]="textAlign"
                                                            [style]="textAlign"
                                                            [footerStyle]="textAlign"
                                                            [minResizableWidth]="c.width ?? defaultMinResizableWidth"
                                                        >
                                                            <ng-template kendoGridCellTemplate let-dataItem>
                                                                @let cancelledData = !dataItem?.isEdited && filterEdited(dataItem);
                                                                <div
                                                                    [ngStyle]="{
                                                                        'text-decoration': cancelledData && currentDataFilter !== DataFilter.Original ? 'line-through' : 'none',
                                                                        'text-decoration-color': cancelledData && currentDataFilter !== DataFilter.Original ? 'red' : 'unset',
                                                                    }"
                                                                >
                                                                    @let data = dataItem | accessValue: c.def;
                                                                    @let containsSeparator = data?.toString().includes(separator) || false;
                                                                    @let containsLineBreak = data?.toString().includes("<br>") || false;
                                                                    @if (containsSeparator) {
                                                                        <span>
                                                                            <span [style.color]="'red'">{{ data.split(separator)[0] }} |</span>
                                                                            {{ data.split(separator)[1] }}
                                                                        </span>
                                                                    } @else if (containsLineBreak) {
                                                                        <span [innerHTML]="data"></span>
                                                                    } @else if (!!data && data.toString() !== "0") {
                                                                        @if (data | isNumber) {
                                                                            @if (c.format === "n2") {
                                                                                {{ Number(Number(data).toFixed(2)) }}
                                                                            } @else {
                                                                                {{ Number(data) }}
                                                                            }
                                                                        } @else if (c.format?.includes("d")) {
                                                                            {{ data | date: c.format }}
                                                                        } @else {
                                                                            {{ data }}
                                                                        }
                                                                    }
                                                                </div>
                                                            </ng-template>
                                                            <ng-template kendoGridFooterTemplate>
                                                                {{ sumColumn(c.def, gridView?.data) }}
                                                            </ng-template>
                                                        </kendo-grid-column>
                                                    }
                                                }
                                            </kendo-grid-column-group>
                                        }
                                    }
                                }
                            </kendo-grid-column-group>
                        }
                    </kendo-grid>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
